import { render, staticRenderFns } from "./_productsV2.vue?vue&type=template&id=1309565c&scoped=true"
import script from "./_productsV2.vue?vue&type=script&lang=js"
export * from "./_productsV2.vue?vue&type=script&lang=js"
import style0 from "./_productsV2.vue?vue&type=style&index=0&id=1309565c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1309565c",
  null
  
)

export default component.exports